import React from 'react'

export default class NotFound extends React.Component {
    render() {
        return(
            <div>
                Pagina del NotFound
            </div>
        )
    }
}